import setCookie from "helpers/setCookie";
import { sendWebViewEvent } from "@Utils/webviewEvents";
import { WEB_VIEW_APP_EVENTS } from "@Utils/webApputils/analyticEvents";

// Saves the currency picked in the preferences modal (desktop and mobile). "default" clears the
// user_currency cookie, so prices go back to the property's own currency. The caller reloads or
// navigates afterwards.
export const persistUserCurrency = (
  currency: string,
  { notifyNativeApp = false }: { notifyNativeApp?: boolean } = {},
) => {
  // Native app only: lets it persist the currency to MMKV
  if (notifyNativeApp) {
    sendWebViewEvent(WEB_VIEW_APP_EVENTS.CURRENCY_CHANGED, {
      currency: currency === "default" ? "" : currency,
    });
  }

  const isDefault = currency === "default";
  const baseDomain = window.location.hostname.split(".").slice(-2).join(".");
  setCookie({
    cname: "user_currency",
    cvalue: isDefault ? "" : currency,
    exdays: isDefault ? -1 : 365, // -1 expires the cookie immediately
    secure: true,
    domain: `.${baseDomain}`,
  });
};

// The modal is closed first; the 100ms lets it close before the page reloads.
export const reloadAfterModalClose = () => {
  setTimeout(() => {
    window.location.reload();
  }, 100);
};
